import { BrowserSupportedFiles, EmbeddableFileTypes, ImageFileType, } from '@libs/types';
import { RegexValidators } from '@libs/validations';
export const FORMAT_OF_IMAGES = Object.values(ImageFileType);
export const FORMAT_OF_EMBEDDED_IMAGES = Object.values(EmbeddableFileTypes);
const isLink = (file) => {
    return typeof file === 'string';
};
export const getSourceFromFile = (file) => {
    const isFileLink = isLink(file);
    return isFileLink ? file : URL.createObjectURL(file);
};
export const checkIfFileIsImage = (file) => {
    const isFileLink = isLink(file);
    const isPngOrJpg = new RegExp(RegexValidators.IS_FILE_PICTURE);
    return isFileLink
        ? isPngOrJpg.test(file)
        : FORMAT_OF_IMAGES.includes(file.type);
};
export const checkIfEmbeddedSupportsFile = (file) => {
    const isFileLink = isLink(file);
    const isPngOrJpg = new RegExp(RegexValidators.IS_SUPPORTED_BY_EMBED);
    return isFileLink
        ? isPngOrJpg.test(file)
        : FORMAT_OF_EMBEDDED_IMAGES.includes(file.type);
};
export const checkIfBrowserSupportsFile = (file) => {
    const isFileLink = isLink(file);
    const isBrowserSuported = new RegExp(RegexValidators.IS_FILE_BROWSER_SUPPORTED);
    return isFileLink
        ? isBrowserSuported.test(file)
        : Object.values(BrowserSupportedFiles).includes(file.type);
};
//# sourceMappingURL=fileChecker.js.map